<template>
	<div ref="idPan" style="height:100%;">
		<div class="InfoTABPan">
			<div class="InfoTAB2" style="margin-left:20px;" @click="onCompInfoClick">{{getLangText("企业")}}</div>
			<div class="InfoTAB2" style="margin-left:10px;" @click="onAcctInfoClick">{{getLangText("账号")}}</div>
			<div class="InfoTAB2_A" style="margin-left:10px;">{{getLangText("AI接口")}}</div>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb; display:grid; grid-template-columns:1fr 1fr 2fr;">
			<div class="Capt DIVNoSelect" style="margin-top:-1px; margin-left:20px; background:#2a83cf; color:#ffffff; text-align:center; height:40px; line-height:40px;" ref="idCanUseTimes"></div>
			<div class="Capt DIVNoSelect" style="margin-top:-1px; margin-left:20px; background:#2a83cf; color:#ffffff; text-align:center; height:40px; line-height:40px;" ref="idUsedTimes"></div>
			<div style="border:0px solid blue; display:grid; grid-template-columns:1fr auto auto auto; padding-right:20px;">
				<div style="border:0px solid red; height:30px;"></div>
				<div class="OPItem" style="border:1px solid #bbbbbb; height:30px; line-height:30px; padding-left:20px; padding-right:20px;" @click="onIntfDet" ref="idMode1">{{getLangText("调用记录")}}</div>
				<div class="OPItem" style="border:1px solid #bbbbbb; height:30px; line-height:30px; padding-left:20px; padding-right:20px;" @click="onRechRec" ref="idMode2">{{getLangText("续费记录")}}</div>
			</div>
		</div>

		<div style="flex: 0 0 auto; width:100%; height:50px;">
			<div ref="idIntfQry" class="SiftPanel" style="display:none;">
				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('日期')}}</div>
				<input type="text" style="width:120px;" maxlength=10 v-model="sYmd" placeholder="YYYY-MM-DD">
				<div class="DIVNoSelect" style="flex:0 0 auto; margin-top:-1px;">-</div>
				<input type="text" style="width:120px;" maxlength=10 v-model="eYmd" placeholder="YYYY-MM-DD">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('设备编码')}}</div>
				<input type="text" style="width:220px;" maxlength=30 v-model="hdCode">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('类型')}}</div>
				<cselect style="position:relative; height:30px; min-width:160px; z-index:999;" :defv="findAiType" v-model="findAiType" :ctrl="ctrlAiType" :csData="dataAiType"></cselect>

				<div class="NButton DIVNoSelect" style="width:32px; height:32px; background:url(../static/images/op_fin.png); margin-top:-1px; margin-left:10px;" @click="onListClick"></div>
			</div>
			<div ref="idRechQry" class="SiftPanel" style="display:none;">
				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('日期')}}</div>
				<input type="text" style="width:120px;" maxlength=10 v-model="sYmd2" placeholder="YYYY-MM-DD">
				<div class="DIVNoSelect" style="flex:0 0 auto; margin-top:-1px;">-</div>
				<input type="text" style="width:120px;" maxlength=10 v-model="eYmd2" placeholder="YYYY-MM-DD">

				<div class="NButton DIVNoSelect" style="width:32px; height:32px; background:url(../static/images/op_fin.png); margin-top:-1px; margin-left:10px;" @click="onListClick"></div>
			</div>
			<div ref="idUsedQry" class="SiftPanel" style="display:none;">
				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('设备编码')}}</div>
				<input type="text" style="width:220px;" maxlength=30 v-model="hdCode2">

				<div class="NButton DIVNoSelect" style="width:32px; height:32px; background:url(../static/images/op_fin.png); margin-top:-1px; margin-left:10px;" @click="onListClick"></div>
			</div>
		</div>

		<div ref="idTablePan" style="width:100%; border:0px solid red; display:none; align-items:center;">
			<ctable :ctrl="ctrlTable"></ctable>
		</div>
		<div ref="idPagePan" style="flex: 0 0 auto; width:100%; height:30px; border:0px solid red; display:none">
			<cpage :key="keyFind" :ctrl="ctrlPage" style="margin-left:0px;"></cpage>
		</div>

	</div>
</template>

<script>

import ctable     from '../cf/ctable'
import cpage      from '../cf/cpage'
import cselect    from '../cf/cselect'

export default {
	name: 'aiInfo',
	components:{
		ctable, cpage, cselect
	},
	data () {
		return {
			mode: 0,
			sYmd: "",
			eYmd: "",
			sYmd2: "",
			eYmd2: "",
			hdCode: "",
			hdCode2: "",
			keyFind: 1000,
			findAiType: "",                   // 接口类型
			ctrlAiType:{
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 10
			},

			ctrlPage: {
				havNote: true,                  //是否显示提示信息
				havGo: true,                    //是否显示页号输入及按钮
				total: 0,                       //总记录数
				pageSize: 10,                   //每页记录条数
				pageIdx: 0,                     //当前页码
				cont:[this.getLangText('共'),this.getLangText('条记录,'),this.getLangText('页'),this.getLangText('条/页'),this.getLangText('页码'),'Go'],
				qryFunc: this.onListClick,      //查询回调函数
			},
			ctrlTable: {                            // 表格控制参数
				headHeight: 50,                     // 表头行的高度
				dataHeight: 46,                     // 数据行的高度
				isCheck: false,                     // 第一列, 是否显示为复选框
				isSplit: false,                     // 固定列、数据列、操作列间是否有渐变分隔
				dataHeads:null,                     // 表格表头定义
				datas:{ data1:[ ], data2:[ ], data3:[ ] },  // 表格数据定义
			},
		}
	},
	mounted: function(){
		this.sYmd = this.getDTStr( 1, 0, 0, 0 );
		this.eYmd = this.getDTStr( 1, 0, 0, 0 );

		this.sYmd2 = this.getDTStr( 1, 0, 0, 0 );
		this.eYmd2 = this.getDTStr( 1, 0, 0, 0 );

		this.$refs["idCanUseTimes"].innerText = LangText("AI可用余额")+" : $"+(this.login.custAiBalance/100).toFixed(2);
		this.$refs["idUsedTimes"].innerText   = LangText("AI可用次数")+" : "+this.login.custAiTimes;

		if( this.login.custAiFlag==1 && this.login.custAiTimes<this.login.custAlarmTimes )
		{  //人脸融合$0.14 * 100次
			this.appRoot.app.showDlgCfm( this.DialogType.Tip, LangText("警告"), LangText("人脸融合")+
							" $"+(this.login.custAiBalance/100).toFixed(2)+" * "+this.login.custAiTimes+" "+LangText("次"), "", {okFunc:null, okParam:null} );
		}

		this.$refs["idMode1"].click();
	},
	computed:{

	},
	methods:{
		onResize: function( ){
			this.childResize( this );
		},
		onCompInfoClick: function(){
			this.$router.push( "/FrameBody/compInfo" );
		},
		onAcctInfoClick: function(){
			this.$router.push( "/FrameBody/acctInfo" );
		},
		/* 查询按钮事件响应 */
		onListClick: function(){
			if( this.mode == 1 )
			{
				let body={ 	pageSize:100,
							curPage:0,
							startYmd: parseInt(this.sYmd.replace(/\-/g,"")),
							endYmd: parseInt(this.eYmd.replace(/\-/g,""))  };
				if( this.findAiType ) body.caiType = parseInt(this.findAiType);
				if( this.hdCode ) body.caiDeviceHdcode = this.hdCode;

				this.doTrade( "POST", ServAddr+"/api/rec/aiIntfQry", this.getIntflistOK, true, body, null );
			}
			else if( this.mode == 2 )
			{
				let body={ pageSize:100, curPage:0, carCustId:this.login.custId,
							startYmd: this.sYmd2, endYmd: this.eYmd2,
							carApplySts: 0 };
				this.doTrade( "POST", ServAddr+"/api/rec/aiRechQry", this.getRechlistOK, true, body, null );
			}
		},

		/* 调用记录 */
		onOpenImgClick: function( item )
		{
			window.open( item.caiImg5, '_blank');
		},
		getIntflistOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.ctrlTable.datas.data1=[];
			this.ctrlTable.datas.data2=[];
			this.ctrlTable.datas.data3=[];

			let sum1=0;
			for(let i=0; i<data.body.list.length; i++ )
			{
				let item=data.body.list[i];
				sum1 = sum1 + item.caiPrice;
				let s1=item.caiImg5.split("?");
				let a1=s1[0].split("/");
				let path=a1[a1.length-1];
				console.log( path );

				this.ctrlTable.datas.data1.push([ item.caiDeviceHdcode ]);

				this.ctrlTable.datas.data2.push( [ this.getAiTypeText(item.caiType), "$"+(item.caiPrice/100).toFixed(2), item.caiLocalDt, item.caiLocalOrderno, '' ] );

				this.ctrlTable.datas.data3.push([ [{capt: this.getLangText("图像"), clk:this.onOpenImgClick, param:item}] ]);
			}

			this.ctrlTable.datas.data1.push([ this.getLangText('汇总') ]);
			this.ctrlTable.datas.data2.push( [ data.body.list.length+this.getLangText('次'), "$"+(sum1/100).toFixed(2), '', '', '' ] );
			this.ctrlTable.datas.data3.push([ '' ]);

			this.ctrlTable.self.show();
			this.ctrlPage.total = data.body.allCnt;
			this.keyFind++;

		},
		onIntfDet: function( e ){
			e.target.style["color"] = "#2fd7ef";
			this.$refs["idMode2"].style["color"] = "";

			this.mode = 1;

			this.$refs["idIntfQry"].style["display"] = "flex";
			this.$refs["idRechQry"].style["display"] = "none";
			this.$refs["idUsedQry"].style["display"] = "none";

			this.$refs["idTablePan"].style["display"] = "flex";
			this.$refs["idPagePan"].style["display"] = "flex";
			this.$refs["idTablePan"].style["height"] = (this.$refs["idPan"].offsetHeight - 182)+"px";

			this.ctrlTable.dataHeads = {
					head1:[                         // 固定列表头
						{ capt:this.getLangText("设备编码"), width:300 },
					],
					head2:[                         // 数据列表头
						{ width:200, capt:this.getLangText('类型') },
						{ width:120, capt:this.getLangText('费用') },
						{ width:200, capt:this.getLangText('时间') },
						{ width:300, capt:this.getLangText('标识号') },
						{ width:100, capt:'' },
					],
					head3:[                         // 操作列表头
						{ capt:this.getLangText('操作'), width:100 },
					],
				};
			this.ctrlTable.datas = { data1:[ ], data2:[ ], data3:[  ] };

			this.ctrlTable.self.show();
		},
		/* 续费记录 */
		getRechlistOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.ctrlTable.datas.data1=[];
			this.ctrlTable.datas.data2=[];
			this.ctrlTable.datas.data3=[];

			for(let i=0; i<data.body.list.length; i++ )
			{
				let item=data.body.list[i];
				this.ctrlTable.datas.data1.push([ item.carId ]);

				this.ctrlTable.datas.data2.push( [ item.carCertificate, "$"+(item.carPreMoney/100).toFixed(2), "$"+(item.carBuyMoney/100).toFixed(2), "$"+(item.carAftMoney/100).toFixed(2), item.carAddDatetime, '' ] );

				this.ctrlTable.datas.data3.push([ '' ]);
			}

			this.ctrlTable.self.show();
			this.ctrlPage.total = data.body.allCnt;
			this.keyFind++;

		},
		onRechRec: function( e ){
			e.target.style["color"] = "#2fd7ef";
			this.$refs["idMode1"].style["color"] = "";

			this.mode = 2;

			this.$refs["idIntfQry"].style["display"] = "none";
			this.$refs["idRechQry"].style["display"] = "flex";
			this.$refs["idUsedQry"].style["display"] = "none";

			this.$refs["idTablePan"].style["display"] = "flex";
			this.$refs["idPagePan"].style["display"] = "flex";
			this.$refs["idTablePan"].style["height"] = (this.$refs["idPan"].offsetHeight - 182)+"px";

			this.ctrlTable.dataHeads = {
					head1:[                         // 固定列表头
						{ capt:this.getLangText("ID"), width:200 },
					],
					head2:[                         // 数据列表头
						{ width:300, capt:this.getLangText('订单号') },
						{ width:250, capt:this.getLangText('续费前余额') },
						{ width:250, capt:this.getLangText('续费金额') },
						{ width:250, capt:this.getLangText('续费后余额') },
						{ width:180, capt:this.getLangText('时间') },
						{ width:100, capt:'' },
					],
					head3:[                         // 操作列表头
						{ capt:this.getLangText('操作'), width:100 },
					],
				};

			this.ctrlTable.datas = { data1:[ ], data2:[ ], data3:[ ] };

			this.ctrlTable.self.show();
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// aiInfo.vue?63a2bac1